export default "__VITE_ASSET__Bjmny2Hu__"